import CryptoJS from "crypto-js";
import Config from "../config";

const EncryptionUtils = {
  storeEncryptedData: (key, data) => {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      Config.keyHash
    ).toString();
    localStorage.setItem(key, encryptedData);
  },

  getDecryptedData: (key) => {
    const encryptedData = localStorage.getItem(key);
    if (encryptedData) {
      const bytes = CryptoJS.AES.decrypt(encryptedData, Config.keyHash);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedData;
    }
    return null;
  },
};

export default EncryptionUtils;
